var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-horizontal-list',{attrs:{"background-color":_vm.blockColor,"title":_vm.data.title,"type":"articles","articles":_vm.articles}})}
var staticRenderFns = []

export { render, staticRenderFns }